import { Component, OnInit, ViewChild } from '@angular/core';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: Date;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-edw',
  templateUrl: './edw.component.html',
  styleUrls: ['./edw.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class EdwComponent implements OnInit {
  hotellistproperty: any;
  apiresult: any;
  selectedReProcessStoreDate: string;

  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe) {
 
  }
  hotellistCopy: any = [] = [];
  Val: string;
  User: string;
  selected: string;
  selectedItems: string;
  Source: string;
  lstAcc: any = [] = [];
  lstgetcmlist: any = [] = [];
  allproperty: any = [] = [];
  hotellist: any = [] = [];
  Userid: any = [];
  SourceBy: string;
  today1: any = new Date();
  today2: any = new Date();
  today3: any = new Date();
  today: any = new Date();
  isProgressing: Boolean = false;
  public Pmscodevalue: any;

  lastThirthydays: any = new Date(this.today.setDate(this.today.getDate() - 30));
  afterThirthydays: any = new Date(this.today.setDate(this.today.getDate() + 30));
  selectedReProcessDate: any = new Date(this.today3.setDate(this.today3.getDate() - 1));
  selectedDate: any = new Date(this.today1.setDate(this.today1.getDate() - 1));
  selectedTOODate: any = new Date(this.today2.setDate(this.today2.getDate() - 1));
  displayedColumns: string[] = ['Status', 'Hotel', 'Accounting date', 'Created date', 'Posted date', 'Mail sent date', 'File name'];
//Indhuja 09-04-2025 Start
  selectedRe_ProcessDate: Date = new Date();         // From Date default to today
  selectedReProcessToDate: Date = new Date();       // To Date default to today
  maxReprocessDate: Date = new Date();
//Indhuja 09-04-2025 End
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  storeUserID: any

  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  pageSize = 50;
  statusResult: string;
  requestPayload: any;
  storeOptionData = "LOG";
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  ngOnInit() {
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.statusResult = "Not Sent"
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.FOOTFALL();
    this.callIDSUsersProperties();
    this.SourceBy = "Report";
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getEDWGetProperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          console.log('this.SourceBy =', this.SourceBy)
          if (this.SourceBy == 'Report') {
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });
          }

          this.dropdownDeptData = this.apiresult
          if (this.SourceBy == 'Report') {
        this.selectedDeptItems = this.getDimensionsByFilter("All");
        console.log('this.StoreValuetest',this.selectedDeptItems[0].propertyCode);
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('this.Pmscodevalue =',this.Pmscodevalue)
          }
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
  }


  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  GetParseonlyDateTime(d) {
    if (d == "") {
      return "";
    }
    return (d.substring(0, 4)) + "-" + (d.substring(4, 6))+ "-" + (d.substring(6, 8))
  }

  changeOption(data: any) {
    console.log("changeOption Value--->" + data);
    this.storeOptionData = data
    if (data == 'Re-process') {
      this.statusResult = ""
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    } else {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    }
  }

  GetEDWLOG() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');

    }
    if ((this.Pmscodevalue == 0 || this.Pmscodevalue == "undefined" || this.Pmscodevalue == "All Property" || this.Pmscodevalue == "") && (this.selectedTOODate >= this.selectedDate)) {
      this.isProgressing = true;
      this.Pmscodevalue = '0';
      this.Userid = localStorage.getItem("Username");

      this.GETEDWFILE();
    }
    else if (this.selectedTOODate >= this.selectedDate) {
      this.isProgressing = true;
      this.Userid = "undefined";
      this.GETEDWFILE();
    }
  }
  GETEDWFILE() {
    if (this.Pmscodevalue == 0 || this.Pmscodevalue == "undefined" || this.Pmscodevalue == "All Property" || this.Pmscodevalue == "") {
      this.Pmscodevalue = 0;
      this.Userid = localStorage.getItem("Username");
    }
    else {
      this.Userid = "undefined";
    }
    //Indhuja 10-04-2025 Start Change the fromDateFormatted,toDateFormatted instead of selectedDate,selectedTOODate
    const fromDateFormatted = this.datePipe.transform(this.selectedRe_ProcessDate, 'yyyyMMdd');
    const toDateFormatted = this.datePipe.transform(this.selectedReProcessToDate, 'yyyyMMdd');
       //Indhuja 10-04-2025 End
    this.apiCallIdsService.getedwlog(this.Pmscodevalue, fromDateFormatted, toDateFormatted, this.Userid,this.statusResult)
      .subscribe(
        data => {
          console.log(data);
          if (data.length < 1) {
            this.displayContent = false
              this.errorMsgSubscription = true
              this.errorMessage = "No Data Found"
              this.toastr.error('No Data Found');
              this.isProgressing = false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
  }
  GetEDWLOGPROCESS() {
    this.isProgressing = true;

    if (this.Pmscodevalue == 0 || this.Pmscodevalue == "undefined" || this.Pmscodevalue == "All Property" || this.Pmscodevalue == "") {
      this.isProgressing = false;
      this.toastr.error('Cannot repost all properties at once, Pls repost one by one. ');
    }
    else {
      this.GETEDWFILEPROCESS();
    }
  }
  GETEDWFILEPROCESS() {
    if (this.Pmscodevalue == 0 || this.Pmscodevalue == "All Property" || this.Pmscodevalue == "") {
      this.Userid = localStorage.getItem("Username");
      this.Pmscodevalue = "undefined";
    }
    else {
      this.Userid = "undefined";
    }

    console.log('selected Date before', this.selectedReProcessDate)
    
    //this.selectedReProcessStoreDate = this.datePipe.transform(this.selectedReProcessDate, 'yyyyMMdd');
    const fromDateFormatted = this.datePipe.transform(this.selectedRe_ProcessDate, 'yyyyMMdd');
    const toDateFormatted = this.datePipe.transform(this.selectedReProcessToDate, 'yyyyMMdd');
  
    console.log("From Date:", fromDateFormatted);
    console.log("To Date:", toDateFormatted);
 
    this.apiCallIdsService.getprocessedwlog(this.Pmscodevalue,fromDateFormatted,toDateFormatted )//this.selectedReProcessStoreDate
      .subscribe(
        data => {
          console.log('Process Data =',data[0].statusDescription)
          if(data[0].statusDescription == 'Successfully Updated' || data[0].statusDescription == 'Successfully Inserted'){
            this.toastr.success(data[0].statusDescription);
          }else{
            this.toastr.error(data[0].statusDescription);
          }
          this.isProgressing = false;
        });
  }

  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'EDW', 'edw upload')
      .subscribe(
        data => {
        });
  }
  onReprocessDateChange(event: any) {
    const selectedDate = new Date(event.value);
    this.selectedRe_ProcessDate = selectedDate;
  
    // Add 30 days from selected date for max allowed to-date
    const newMaxDate = new Date(selectedDate);
    newMaxDate.setDate(newMaxDate.getDate() + 30);
    this.maxReprocessDate = newMaxDate;
  
    // If selected To Date is beyond max, clear it
    if (this.selectedReProcessToDate && this.selectedReProcessToDate > this.maxReprocessDate) {
      this.selectedReProcessToDate = null;
    }
  
    // ❗ Check if From Date is greater than To Date
    if (this.selectedReProcessToDate && selectedDate > this.selectedReProcessToDate) {
      this.toastr.error('To Date should be greater than or equal to From Date') 
        
      this.selectedReProcessToDate = null;
    }
  }
}
